module.exports = __webpack_public_path__ + "img/柯马-1.6a8240b8.png";